import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { toast } from '../hooks/use-toast';
import { Loader2 } from 'lucide-react';

const AuthModal = ({ open, onClose }) => {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    try {
      const result = await login(credentialResponse.credential);
      
      if (result.success) {
        toast({
          title: 'Welcome!',
          description: 'Successfully logged in with Google',
        });
        onClose();
      } else {
        toast({
          title: 'Login Failed',
          description: result.error || 'Unable to login. Please try again.',
          variant: 'destructive',
        });
      }
    } catch (error) {
      toast({
        title: 'Login Error',
        description: 'An error occurred during login',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleError = () => {
    toast({
      title: 'Login Failed',
      description: 'Google login was cancelled or failed',
      variant: 'destructive',
    });
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">Welcome to Agora</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col items-center space-y-4 py-6">
          <p className="text-gray-600 text-center">
            Sign in with your Google account to start buying and selling
          </p>

          {loading ? (
            <div className="flex items-center space-x-2 py-6">
              <Loader2 className="w-6 h-6 animate-spin text-red-500" />
              <span className="text-gray-600">Signing you in...</span>
            </div>
          ) : (
            <div className="w-full flex justify-center">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                useOneTap
                theme="outline"
                size="large"
                text="signin_with"
                shape="rectangular"
                logo_alignment="left"
              />
            </div>
          )}

          <div className="text-sm text-gray-500 text-center mt-4">
            By continuing, you agree to Agora's Terms of Service and Privacy Policy
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
